import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DirectionProvider, RouteLoader } from "@envirohub/ui";
import { VendorZoneGuard } from "@/components/VendorStatusGate";
import { DocumentMeta } from "@/components/DocumentMeta";
import { PrivateRoute } from "@/components/PrivateRoute";

const PublicLayout = lazy(() => import("./layouts/PublicLayout"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const ForgotPassword = lazy(() => import("./pages/ForgotPasswordPage"));
const ChangePasswordPage = lazy(() => import("./pages/ChangePasswordPage"));
const OtpPage = lazy(() => import("./pages/OtpPage"));

export default function App() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
  }, [i18n.language]);

  return (
    <DirectionProvider dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      <BrowserRouter>
        <DocumentMeta />
        <Suspense fallback={<RouteLoader fullScreen />}>
          <Routes>
            <Route
              element={
                <Suspense fallback={<RouteLoader fullScreen />}>
                  <PublicLayout />
                </Suspense>
              }
            >
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/verify" element={<OtpPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/change-password"
                element={
                  <PrivateRoute>
                    <ChangePasswordPage />
                  </PrivateRoute>
                }
              />
            </Route>

            {/*
             * All authenticated routes are owned by VendorZoneGuard.
             * It renders a full-screen loader while status is unknown and then
             * renders only the route tree for the vendor's org-status zone.
             * VendorLayout (and all portal queries) can only mount when ACTIVE.
             */}
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <VendorZoneGuard />
                </PrivateRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </DirectionProvider>
  );
}
